"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

exports.__esModule = true;
exports.TipList = void 0;

require("antd/lib/table/style");

var _table = _interopRequireDefault(require("antd/lib/table"));

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _mobxReact = require("mobx-react");

var _HtmlRender = require("../../../../react-static/components/HtmlRender");

var _Link = require("../../../../react-static/components/Link");

var _Core = require("../../../../components/Core");

var _class, _class2, _temp;

var TipList = (0, _mobxReact.observer)(_class = (_temp = _class2 =
/*#__PURE__*/
function (_Component) {
  (0, _inheritsLoose2.default)(TipList, _Component);

  function TipList(props) {
    return _Component.call(this, props) || this;
  }

  var _proto = TipList.prototype;

  _proto.render = function render() {
    var tips = this.props.tips;
    return _react.default.createElement(_Core.Box, {
      mb: 4
    }, _react.default.createElement("h2", null, "Tips"), _react.default.createElement(_table.default, {
      rowKey: "id",
      columns: TipList.Columns,
      dataSource: tips,
      pagination: false
    }));
  };

  return TipList;
}(_react.Component), (0, _defineProperty2.default)(_class2, "Columns", [{
  title: "Title",
  dataIndex: "title",
  width: 150
}, {
  title: "Item Type",
  dataIndex: "thingTypeName",
  width: 100,
  render: function render(thingTypeName, record) {
    return record.thingTypePath && thingTypeName ? _react.default.createElement(_Link.Link, {
      href: record.thingTypePath
    }, thingTypeName) : thingTypeName ? thingTypeName : "-";
  }
}, {
  title: "Description",
  dataIndex: "description",
  render: function render(description) {
    return _react.default.createElement(_HtmlRender.HtmlRender, {
      html: description
    });
  }
}]), _temp)) || _class;

exports.TipList = TipList;